import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { THEME_COLORS } from "../../context/constants";

const useStyles = makeStyles((theme: Theme) => ({
  inputLabel: {
    color: "#000000 !important", // Default label color (black)
    "&.Mui-focused": {
      color: theme.palette.primary.main + " !important", // Primary color when focused
      opacity: 1 + " !important",
    },
    "&.MuiFormLabel-filled": {
      opacity: 0.5 + " !important", // Primary color when filled
    },
    "&.MuiFormLabel-root": {
      opacity: 0.5,
    },
  },
  titles: {
    padding: "4px",
  },
  aiCheckboxContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(2),
  },
  aiCheckboxLabel: {
    fontSize: "14px",
    color: theme.palette.primary.dark,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  checkboxRoot: {
    marginRight: "4px",
    "& svg": {
      fill: THEME_COLORS.darkYellow,
    },
  },
}));

export default useStyles;
